import type {
  CreditConsultationValue,
  PolicyholderRunRule,
} from '@/shared/api/resources';

/** Verde e o positivo, vermelho o negativo e amarelo o que ainda nao tem resposta. */
export type CorDaAnalise = 'success' | 'warning' | 'danger';

/**
 * A cor da regra pela coluna da matriz de decisao, a mesma leitura do motor: S segue, V e
 * o dado presente que violou a regra. Faltar dado ou depender de alguem (colunas A e E,
 * pendencias) nao e resultado negativo, e por isso fica em amarelo.
 */
export function corDaRegra(regra: PolicyholderRunRule): CorDaAnalise {
  if (regra.effective === 'segue') return 'success';
  if (regra.effective === 'recusado' || regra.column === 'V') return 'danger';
  return 'warning';
}

/** Elementos em que zero e limpo e qualquer valor acima dele e registro negativo. */
const zeroELimpo = new Set([
  'vgd_divida_ativa_total',
  'vgd_divida_ativa_previdenciaria',
  'vgd_divida_ativa_nao_previdenciaria',
  'vgd_divida_ativa_fgts',
  'vgd_divida_ativa_quantidade',
  'vgd_sancoes_quantidade',
  'vgd_protestos_quantidade',
  'vgd_protestos_valor',
  'vgd_apontamentos_quantidade',
  'vgd_apontamentos_maior_valor',
  'vgd_acoes_judiciais_quantidade',
  'vgd_acoes_judiciais_valor',
]);

/**
 * A cor do valor da consulta, so onde o proprio dado diz se e bom ou ruim. Score,
 * faturamento, capital, porte e endividamento ficam sem cor: quem os julga sao as
 * regras, com os parametros da empresa. O dado que nao veio tambem fica sem cor.
 */
export function corDoValor(
  valor: CreditConsultationValue | undefined,
): CorDaAnalise | null {
  if (!valor || valor.situation !== 'encontrado') return null;
  switch (valor.element) {
    case 'situacao_cadastral':
      return valor.value_text?.trim().toLowerCase() === 'ativa' ? 'success' : 'danger';
    case 'vgd_indicador_negativo':
      return valor.value_flag ? 'danger' : 'success';
    case 'vgd_sancoes_tipos':
      return 'danger';
  }
  if (!zeroELimpo.has(valor.element)) return null;
  const numero = valor.value_money ? valor.value_money.amount : valor.value_integer;
  if (numero === null || numero === undefined) return null;
  return numero === 0 ? 'success' : 'danger';
}
